import React from "react";
import contextProvider from "app/contextProvider";
import { withRouter } from "react-router-dom";
import { Row, Col } from "reactstrap";
import _ReactOBaseComponent from "app/_L0_components/_ReactOBaseComponent";
import { _LoadingWrapper } from "app/_L0_components/Widgets/_LoadingKit";
import Section from "app/_L1_components/Layout/Section";
import Panel from "app/_L1_components/Layout/Panel";
import ReactOForm from "app/_L1_components/Elements/ReactOForm";
import ReactOFormInput from "app/_L1_components/Elements/ReactOFormInput";
import ReactOButton from "app/_L1_components/Elements/ReactOButton";
import ReactOActionBar from "app/_L1_components/Elements/ReactOActionBar";

class NotificationsSettings extends _ReactOBaseComponent {
  constructor(props) {
    var initState = {
      loading: false,
      loading_probes: false,
      data: null,
    };
    super(props, initState);
    this.apiStore = null;
    this.actionsShelf = null;
    this._REFRESH_TOUT = null;
    this._LOADING_ENABLED = true;
  }

  /////////////////////////
  //	Lifecycle methods
  //

  onComponentDidMount() {
    this.mounted = true;
    this.apiStore = this.getAppContext().getApiStoreService();
    if (this.getAppContext().isCloud()) {
      this.getSettings();
    }
  }

  onComponentWillUnmount() {}

  getSettings(cb) {
    this.setState(
      {
        loading: true,
      },
      () => {
        this.apiStore.fire("get_notifications", {
          ___onSuccess: (_, data) => {
            if (this.mounted) {
              this._probe_setup_form.init(data || {});
              this.setState({
                data: data,
                loading: false,
              });
            }
          },
        });
      },
    );
  }

  saveSettings(data, cb) {
    this.setState(
      {
        loading: true,
      },
      () => {
        this.apiStore.fire("set_notifications", {
          data,
          ___onSuccess: (_, data) => {
            if (this.mounted) {
              this._probe_setup_form.init(data);
              this.setState({
                data: data,
                loading: false,
              });
            }
          },
        });
      },
    );
  }

  getMailLabel() {
    let label = "Mail notifications";
    if (
      this.state.data?.smart_notifications &&
      this.state.data?.smart_notifications == "yes"
    ) {
      label = "Smart mail notifications";
    }
    return label;
  }

  onRender() {
    let mailLabel = this.getMailLabel();
    return (
      <div className="">
        <Section designType="narrow" className="mt-3">
          <_LoadingWrapper loadingPlug={this.state.loading}>
            <div className="d-flex py-1">
              <div className="flex-shrink-1 mr-3" style={{ fontSize: "40px" }}>
                <div style={{ display: "inline-block" }}>
                  <span
                    className="icon-envelop"
                    style={{ fontSize: "1.25rem" }}
                  ></span>
                </div>
                <div style={{ display: "inline-block" }}>
                  <h5 className="ml-2">Notifications</h5>
                </div>
              </div>
            </div>
            <ReactOForm
              onControllerReady={(form_controller) => {
                this._probe_setup_form = form_controller;
              }}
              preInit={(form_data) => {
                // console.log("FORM DATA", form_data);
                if (form_data.notifications_off_from_to) {
                  let time = form_data.notifications_off_from_to.split("-");
                  form_data.notifications_off_from = time[0];
                  form_data.notifications_off_to = time[1];
                  form_data.from_to_enabled = "yes";
                } else {
                  form_data.notifications_off_timezone =
                    Intl.DateTimeFormat().resolvedOptions().timeZone;
                }
                if (form_data.measures) {
                  form_data.measures_enabled = "yes";
                }
                if (form_data.snapshot) {
                  form_data.snapshot_enabled = "yes";
                } else {
                  form_data.timezone_snapshot =
                    Intl.DateTimeFormat().resolvedOptions().timeZone;
                }
                if (!form_data.smart_notifications) {
                  form_data.smart_notifications = "no";
                }
                return form_data;
              }}
              preSubmit={(form_data) => {
                let dataToSubmit = { ...form_data };
                // DESTROY NOTIFICATIONS FROM TO
                if (
                  form_data.from_to_enabled &&
                  form_data.from_to_enabled == "yes"
                ) {
                  dataToSubmit.notifications_off_from_to = `${form_data.notifications_off_from}-${form_data.notifications_off_to}`;
                } else {
                  delete dataToSubmit.notifications_off_from_to;
                  delete dataToSubmit.notifications_off_timezone;
                }
                // DESTROY MEASURES
                if (
                  form_data.measures_enabled &&
                  form_data.measures_enabled == "no"
                ) {
                  delete dataToSubmit.measures;
                  delete dataToSubmit.notif_meas_time;
                  if (form_data.reachability) {
                    delete dataToSubmit.reachability;
                  }
                } else {
                  dataToSubmit.notif_meas_time = parseInt(
                    form_data.notif_meas_time,
                  );
                  dataToSubmit.reachability = form_data.measures;
                }
                // DESTROY SNAPHSOT
                if (
                  form_data.snapshot_enabled &&
                  form_data.snapshot_enabled == "no"
                ) {
                  delete dataToSubmit.snapshot;
                  delete dataToSubmit.snapshot_times;
                  delete dataToSubmit.timezone_snapshot;
                }

                return dataToSubmit;
              }}
              onSubmit={this.saveSettings.bind(this)}
            >
              <ReactOFormInput type="hidden" data_key="internal" />
              <ReactOFormInput type="hidden" data_key="notif_reach_time" />
              <ReactOFormInput type="hidden" data_key="reachability" />
              <ReactOFormInput type="hidden" data_key="smart_notifications" />
              <ReactOFormInput
                type="hidden"
                data_key="notifications_off_timezone"
              />
              <ReactOFormInput type="hidden" data_key="timezone_snapshot" />
              <Panel
                rounded
                className="mb-4 rounded-bottom"
                header="General settings"
                style={{
                  minHeight: "100px",
                }}
              >
                {/* DISABLED NOTIFY */}
                <Row className="">
                  <Col className="mb-2" xs={12}>
                    <ReactOFormInput
                      type="switch"
                      auxiliary
                      label="DISABLE NOTIFICATIONS (FROM / TO)"
                      data_key="from_to_enabled"
                      size="sm"
                      default="no"
                      switchOnValue="yes"
                      switchOffValue="no"
                    />
                    <ReactOFormInput
                      type="hidden"
                      data_key="notifications_off_from_to"
                    />
                  </Col>
                  <Col xs={12} sm={2} className="mt-3 mt-sm-0">
                    <ReactOFormInput
                      type="text"
                      auxiliary
                      data_key="notifications_off_from"
                      help={(form_data) => {
                        return `${form_data.notifications_off_timezone} timezone`;
                      }}
                      showIf={(form_data) => {
                        return form_data.from_to_enabled == "yes";
                      }}
                      size="md-3"
                      placeholder="HH:MM"
                      validators={[
                        {
                          func: (value) => {
                            return (
                              this._probe_setup_form.getEntry(
                                "from_to_enabled",
                              ) == "no" ||
                              /^(2[0-3]|[01][0-9]):[0-5][0-9]$/i.test(value)
                            );
                          },
                          invalid_text: "Time must be in HH:MM format",
                        },
                      ]}
                    />
                  </Col>
                  <Col xs={12} sm={2} className="mt-3 mt-sm-0">
                    <ReactOFormInput
                      type="text"
                      auxiliary
                      data_key="notifications_off_to"
                      showIf={(form_data) => {
                        return form_data.from_to_enabled == "yes";
                      }}
                      // defineIf={(form_data) => {
                      //   return form_data.from_to_enabled == "yes";
                      // }}
                      size="md-3"
                      placeholder="HH:MM"
                      validators={[
                        {
                          func: (value) => {
                            return (
                              this._probe_setup_form.getEntry(
                                "from_to_enabled",
                              ) == "no" ||
                              /^(2[0-3]|[01][0-9]):[0-5][0-9]$/i.test(value)
                            );
                          },
                          invalid_text: "Time must be in HH:MM format",
                        },
                      ]}
                    />
                  </Col>
                </Row>
              </Panel>
              <Panel
                rounded
                className="mb-4 rounded-bottom"
                header="Probe activity"
                style={{
                  minHeight: "100px",
                }}
              >
                {/* MAIL REACHABILITY */}
                <Row className="">
                  <Col xs={12}>
                    <Row className="mb-2">
                      <Col xs={12} sm={6} lg={6}>
                        <ReactOFormInput
                          type="switch"
                          auxiliary
                          label={mailLabel}
                          data_key="measures_enabled"
                          size="sm"
                          default="no"
                          switchOnValue="yes"
                          switchOffValue="no"
                        />
                      </Col>
                    </Row>

                    <Row className="">
                      <Col xs={12} md={8}>
                        <ReactOFormInput
                          type="text"
                          data_key="measures"
                          showIf={(form_data) => {
                            return form_data.measures_enabled == "yes";
                          }}
                          defineIf={(form_data) => {
                            return form_data.measures_enabled == "yes";
                          }}
                          label="SEND MAIL TO"
                          size="md"
                          default=""
                          help="Use a comma to separate more mail address"
                          placeholder="e.g. mail@example.com, mail@example.com"
                          validators={[
                            {
                              func: (value) => {
                                return /^(?:[\w.-]+\@[\w-]+\.?[\w-]+\.{1}[a-zA-Z]+){1}(?:\,\s[\w.-]+\@[\w-]+\.?[\w-]+\.{1}[a-zA-Z]+){0,}$/i.test(
                                  value,
                                );
                              },
                              invalid_text: "Type a valid mail address",
                            },
                          ]}
                        />
                      </Col>
                      <Col xs={12} md={4}>
                        <ReactOFormInput
                          type="text"
                          help="Trigger after the given minutes without syncs."
                          data_key="notif_meas_time"
                          showIf={(form_data) => {
                            return form_data.measures_enabled == "yes";
                          }}
                          label="NOTIFY TIME"
                          size="md"
                          placeholder="e.g. 10"
                          default="15"
                          validators={[
                            {
                              func: (value) => {
                                return /^[0-9]+$/i.test(value);
                              },
                              invalid_text: "Type notify time",
                            },
                          ]}
                        />
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Panel>
              <Panel
                rounded
                className="mb-4 rounded-bottom"
                header="Snapshot"
                style={{
                  minHeight: "100px",
                }}
              >
                {/* SNAPSHOT */}

                <Row className="mb-2">
                  <Col className="mb-2" xs={12}>
                    <ReactOFormInput
                      type="switch"
                      auxiliary
                      label="Mail snapshot"
                      data_key="snapshot_enabled"
                      size="sm"
                      default="no"
                      switchOnValue="yes"
                      switchOffValue="no"
                    />
                  </Col>
                  <Col xs={12} sm={8}>
                    {/* <Label>MAIL SNAPSHOT</Label> */}
                    <ReactOFormInput
                      type="text"
                      data_key="snapshot"
                      // disabledIf={(form_data) => {
                      //   return form_data.snapshot_enabled == "no";
                      // }}
                      showIf={(form_data) => {
                        return form_data.snapshot_enabled == "yes";
                      }}
                      defineIf={(form_data) => {
                        return form_data.snapshot_enabled == "yes";
                      }}
                      label="SEND MAIL TO"
                      size="md"
                      default=""
                      help="Use a comma to separate more mail address"
                      placeholder="e.g. mail@example.com, mail@example.com"
                      validators={[
                        {
                          func: (value) => {
                            return (
                              (this._probe_setup_form.getEntry(
                                "notifications_measures.enable",
                              ) == "no" &&
                                value == "") ||
                              /^(?:[\w.-]+\@[\w-]+\.?[\w-]+\.{1}[a-zA-Z]+){1}(?:\,\s[\w.-]+\@[\w-]+\.?[\w-]+\.{1}[a-zA-Z]+){0,}$/i.test(
                                value,
                              )
                            );
                          },
                          invalid_text: "Type a valid mail address",
                        },
                      ]}
                    />
                  </Col>
                  <Col xs={12} sm={4}>
                    <ReactOFormInput
                      type="array"
                      data_key="snapshot_times"
                      label="Specific hours"
                      showIf={(form_data) => {
                        return form_data.snapshot_enabled == "yes";
                      }}
                      help={(form_data) => {
                        return `${form_data.timezone_snapshot} timezone`;
                      }}
                      onRender={(
                        form_array_data,
                        remove_action,
                        add_action,
                      ) => {
                        return (
                          <div>
                            {form_array_data.map((_CURR_entry, _CURR_idx) => {
                              return (
                                <ReactOFormInput
                                  key={"snapshot_times." + _CURR_idx}
                                  className="mb-1"
                                  type="text"
                                  data_key={"snapshot_times." + _CURR_idx}
                                  size="md"
                                  append={
                                    <ReactOButton
                                      onClick={() => {
                                        remove_action(_CURR_idx);
                                      }}
                                      icon="minus"
                                      color="gray200"
                                    />
                                  }
                                  // autofocus
                                  //	onValueChange={(form_ctrl, new_value) => {
                                  //		form_ctrl.handleFormChange('bssid_specific_extra.' + _CURR_idx, new_value)
                                  //		form_ctrl.handleFormChange('bssid', form_ctrl.getEntry('bssid_specific_extra').join(','))
                                  //	}}
                                  placeholder="HH:MM"
                                  validators={[
                                    // ^(2[0-3]|[01][0-9]):[0-5][0-9]$
                                    {
                                      func: (value) => {
                                        return /^(2[0-3]|[01][0-9]):[0-5][0-9]$/i.test(
                                          value,
                                        );
                                      },
                                      invalid_text:
                                        "Time must be in HH:MM format",
                                    },
                                  ]}
                                />
                              );
                            })}
                            <ReactOActionBar
                              key="2"
                              align="right"
                              padding="0px"
                            >
                              <ReactOButton
                                onClick={add_action}
                                icon="plus"
                                color="gray200"
                              />
                            </ReactOActionBar>
                          </div>
                        );
                      }}
                    />
                  </Col>
                </Row>
                <Row></Row>
              </Panel>
              <ReactOActionBar align="right" padding="0">
                <ReactOFormInput
                  type="submit"
                  value="Save"
                  color="primary"
                  icon="save"
                >
                  Save
                </ReactOFormInput>
              </ReactOActionBar>
            </ReactOForm>
          </_LoadingWrapper>
        </Section>
      </div>
    );
  }
}

export default contextProvider(
  withRouter(NotificationsSettings),
  //	withDefinedContext(Account, 'Account', context_exposed_methods),
  {
    define: null,
  },
);
